export class RequestGeneration {
  private generation = 0;
  next() { this.generation += 1; return this.generation; }
  invalidate() { this.generation += 1; }
  isCurrent(candidate: number) { return candidate === this.generation; }
}
